<script setup lang="ts">
import { computed } from 'vue'

import { usePageStore } from '@toni/rendering/src/stores/page'

import { useContentBlock } from '../../../content-blocks/composables/use-content-block'
import BlockSectionTitle from './BlockSectionTitle.vue'
import BlockHeading from './BlockHeading.vue'
import BlockSectionHeading from './BlockSectionHeading.vue'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'interline')

const pageStore = usePageStore()
const pageMeta = computed(() => pageStore.pageData.pageMeta)

const isStructure = computed(() => pageMeta.value.structureTermType === 'structure')

</script>

<template>
  <BlockSectionHeading v-if="isStructure"
                       :id="id" />
  <component :is="contentBlock.data.interline.label ? BlockSectionTitle : BlockHeading"
             v-else-if="!isStructure"
             :id="id" />
</template>
